import { Link } from 'react-router-dom';
import { Separator } from '../ui/separator';

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="font-serif text-2xl font-semibold">
              SkinUse
            </Link>
            <p className="mt-4 text-sm text-primary-foreground/70 leading-relaxed">
              The Intelligent Vanity. Your personalized guide to radiant skin and healthy hair.
            </p>
          </div>

          {/* Content */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-gold mb-4">Content</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/daily-drop" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">The Daily Drop</Link></li>
              <li><Link to="/deep-dives" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">Deep Dives</Link></li>
              <li><Link to="/video-vault" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">Video Vault</Link></li>
              <li><Link to="/knowledge" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">Knowledge Corner</Link></li>
            </ul>
          </div>

          {/* Features */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-gold mb-4">Features</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/quiz" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">Quiz & Trivia</Link></li>
              <li><Link to="/deals" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">Smart Discounts</Link></li>
              <li><Link to="/dashboard" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">Daily Advice</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider text-gold mb-4">Account</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/profile" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">Profile</Link></li>
              <li><Link to="/login" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">Sign In</Link></li>
              <li><Link to="/register" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors">Create Account</Link></li>
            </ul>
          </div>
        </div>

        <Separator className="my-12 bg-primary-foreground/10" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-primary-foreground/50">
          <p>&copy; {new Date().getFullYear()} SkinUse. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-primary-foreground transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-primary-foreground transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
